import type { DefaultDashboardDefinition } from './dashboard-definition';

export const accessRoleDashboard: DefaultDashboardDefinition = {
  id: "configuration.access-role",
  appId: "configuration",
  name: "Access Role dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: "."
  },
  queryScope: null,
  placements: [
    {
      id: "organisation.summary.role.policies",
      widgetId: "organisation.summary.role.policies",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1
      }
    },
    {
      id: "organisation.summary.role.groups",
      widgetId: "organisation.summary.role.groups",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1
      }
    }
  ]
};
